import React from 'react';
import { Multiselect } from 'fw/forms';
 
class CompanyMultiselect extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            ...this.initialState(),
            loading: true,
        }
    }
 
    initialState = () => {
    }
 
    componentDidMount = () => {
        this.setState({
            loading: false,
            items: this.props.companies.map((item) => { return { label: item.name, value: item.id } })
        });
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            items: nextProps.companies.map((item) => { return { label: item.name, value: item.id } })
        });
    }

    render() {
        if (this.state.loading)
            return null;

        return (
            <Multiselect
                {...this.props}
                items={this.state.items} />
        )
    }
}
 
export default CompanyMultiselect;
 
// Mark this as a form component
CompanyMultiselect.defaultProps = {
    formControl: true,
    managed: false
};


// WEBPACK FOOTER //
// ./src/areas/shared/controls/companyMultiselect/CompanyMultiselect.js